<template>
  <v-avatar color="white">
    <base-image :src="url" alt="avatar" />
  </v-avatar>
</template>

<script>
import BaseImage from "Public/components/BaseImage";
export default {
  name: "AvatarImage",
  components: { BaseImage },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
